import { useEffect, useRef } from 'react';
import { CodeReveal } from './CodeReveal';
import { useShellToast, copyToClipboard } from './Toast';

interface RedeemSuccessProps {
  sku: { name: string; imageUrl?: string };
  code?: string;
  onViewHistory: () => void;
  onBackToRewards: () => void;
  onBackToCatalogue?: () => void;
}

export function RedeemSuccess({ sku, code, onViewHistory, onBackToRewards, onBackToCatalogue }: RedeemSuccessProps) {
  const showToast = useShellToast();
  const autoCopied = useRef(false);

  useEffect(() => {
    if (code && !autoCopied.current) {
      autoCopied.current = true;
      copyToClipboard(code).then((ok) => {
        if (ok) showToast('Code copied to clipboard');
      });
    }
  }, [code, showToast]);

  return (
    <div className='flex min-h-0 flex-1 flex-col gap-[10px]'>
      {/* Back arrow */}
      <button type='button' onClick={onBackToCatalogue ?? onBackToRewards}
        className='shrink-0 self-start border-none bg-transparent p-0 text-sm font-semibold text-[#FFFFFF]/90 transition-opacity hover:opacity-80'>
        &larr; Catalog
      </button>

      <p className='text-[17px] font-semibold text-white'>Reward redeemed</p>

      {/* Art — uses hero gradient background, same size as hub */}
      <div className='relative mx-auto w-full shrink-0' style={{ maxWidth: 240 }}>
        <img src='/playcast-hero-gradient.svg' alt='' className='block w-full' draggable={false} />
        {sku.imageUrl && (
          <img src={sku.imageUrl} alt={sku.name} className='absolute inset-0 m-auto h-[75%] w-[75%] object-contain' />
        )}
      </div>

      {code && <CodeReveal code={code} onCopied={() => showToast('Code copied')} />}

      <div className='flex items-start gap-2' style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.05)' }}>
        <svg width='14' height='14' viewBox='0 0 16 16' className='mt-0.5 shrink-0' aria-hidden='true'>
          <circle cx='8' cy='8' r='6.5' fill='none' stroke='rgba(255,255,255,0.5)' strokeWidth='1.2' />
          <path d='M8 5 V8.5 M8 10.5 V11' stroke='rgba(255,255,255,0.5)' strokeWidth='1.3' strokeLinecap='round' />
        </svg>
        <span className='text-[13px] text-[#FFFFFF]/80' style={{ lineHeight: 1.4 }}>
          Saved to Redemption history — find it anytime in Settings.
        </span>
      </div>

      <div className='mt-auto flex flex-col gap-2'>
        <button type='button' onClick={onViewHistory}
          style={{ minHeight: 44, borderRadius: 9999, border: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.12)' }}
          className='flex w-full items-center justify-center text-[15px] font-semibold text-white transition-opacity hover:opacity-80'>
          View redemption history
        </button>
        <button type='button' onClick={onBackToRewards}
          className='flex w-full items-center justify-center border-none bg-transparent p-0 text-[13px] text-[#FFFFFF]/80 underline transition-opacity hover:opacity-80'
          style={{ textUnderlineOffset: 2 }}>
          Back to Rewards
        </button>
      </div>

    </div>
  );
}
